import { roundNumber } from '@/utils/numberHelpers';

export const mapDataForChart = rawData =>
  Object.entries(rawData).map(([date, dataItem]) => ({
    date,
    averageWorkedHours: roundNumber((dataItem.average_minutes_per_employee_worked / 60), 2),
    averagePlannedHours: roundNumber((dataItem.average_minutes_per_employee_planned / 60), 2),
  }));
